import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';

import type { RootState } from '../../RootState';

import { initialState } from './state';

const pageTitleSlice = createSlice({
  name: 'pageTitle',
  initialState,
  reducers: {
    setCurrentEntityName: (state, action: PayloadAction<string | undefined>) => {
      state.currentEntityName = action.payload;
    },
    rehydrate: (state) => {
      _.merge(state, initialState);
    },
  },
});

export const pageTitleToolkit = Object.freeze({
  initialState,
  actions: pageTitleSlice.actions,
  selectors: {
    state: (state: RootState) => state.pageTitle,
    rehydrate: (state: RootState) => state.pageTitle,
    currentEntityName: (state: RootState) => state.pageTitle.currentEntityName,
  },
});

export const pageTitleReducer = pageTitleSlice.reducer;
